import AsyncStorage from '@react-native-community/async-storage';
import { NavigationContainer } from '@react-navigation/native';
import i18n from 'i18n-js';
import { Provider } from 'mobx-react';
import 'mobx-react-lite/batchingForReactDom';
import { NativeBaseProvider } from 'native-base';
import React from 'react';
import 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import Loading from './components/basic/Loading';
import theme from './constants/theme';
import LocalizationContext from './context/LocalizationContext';
import AppNavigator from './navigators/AppNavigator';
//stores
import authStore from './stores/authStore';
import creditStore from './stores/creditStore';
import feedStore from './stores/feedStore';
import memberStore from './stores/memberStore';
import notificationStore from './stores/notificationStore';
import orderStore from './stores/orderStore';
import pospalStore from './stores/pospalStore';
import reservationStore from './stores/reservationStore';
import userCouponStore from './stores/userCouponStore';
import moment from 'moment'

export default function App() {
  const [token, setToken] = React.useState(undefined)
  const [isLoading, setIsLoading] = React.useState(true)
  const [locale, setLocale] = React.useState('zh-Hant')
  const localizationContext = React.useMemo(
    () => ({
      t: (scope, options) => i18n.t(scope, { locale, ...options }),
      locale,
      setLocale,
    }),
    [locale]
  )


  React.useEffect(() => {
    const componentDidMount = async () => {
      const tokenExpAt = await AsyncStorage.getItem('@tokenExpAt')
      if (moment().isAfter(tokenExpAt)) {
        await AsyncStorage.removeItem('@token')
        await AsyncStorage.removeItem('@tokenExpAt')
      }
      const token = await AsyncStorage.getItem('@token')
      console.log(token)
      setToken(token)
      const locale = await AsyncStorage.getItem('@locale')
      if (locale) {
        setLocale(locale)
      }
      setIsLoading(false)
    }
    componentDidMount()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Provider
      authStore={authStore}
      memberStore={memberStore}
      orderStore={orderStore}
      creditStore={creditStore}
      feedStore={feedStore}
      pospalStore={pospalStore}
      reservationStore={reservationStore}
      userCouponStore={userCouponStore}
      notificationStore={notificationStore}
    >
      <SafeAreaProvider>
        <LocalizationContext.Provider value={localizationContext}>
          <NativeBaseProvider theme={theme}>
            <NavigationContainer>
              <AppNavigator token={token} />
            </NavigationContainer>
          </NativeBaseProvider>
        </LocalizationContext.Provider>
      </SafeAreaProvider>
    </Provider>
  );
}

